import i18n from '../plugins/i18n/index';

export default {
  computed: {
    langs() {
      return Object.keys(i18n.messages);
    },
    currentLang() {
      return i18n.locale;
    },
    is_EN_active() {
      if (i18n.locale === 'en') {
        return true; // return 'sausages'
      }
      return false; // return 'bratwurst'
    },
  },
  methods: {
    toggleLang() {
      if (this.currentLang === 'en') {
        i18n.locale = 'de';
      } else {
        i18n.locale = 'en';
      }
    },
  },
};
